import axios from "axios";
import React, { useEffect, useState } from "react";
import BasicTenderInfo from "../BriefTender/BasicTenderInfo";
import { Box, Button, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import person from "../../../assets/famicons_man-outline.png"

const DecryptBid = () => {
  const [tender, setTender] = useState();
  const [decrypted, setDecrypted] = useState(false);
  const [bidsOpened, setBidsOpened] = useState();
  const { tenderId } = useParams();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [timeLeft, setTimeLeft] = useState("");
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getTender = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setTender(res.data);
        const isOpener = res.data.openers.filter(opener => opener.opener.email === storedUser.username);
        setDecrypted(isOpener[0]?.isOpened)
        setBidsOpened(res.data.isBidOpened)
      } catch (error) {
        console.error("Error updating tender status:", error);
      }
    };
    getTender();
  }, []);

  const handleDecrypt = async () => {
    setLoading(true)
    try {
        const res = await axios.put(
          `${process.env.REACT_APP_BACKEND_URL}/bid-opening?tenderId=${tenderId}&username=${storedUser.username}`,
          null
          ,{ headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDecrypted(true);
        setBidsOpened(res.data.isBidOpened)
      } catch (error) {
        console.error("Error updating tender status:", error);
      } finally {
        setLoading(false)
      }
  }

  const formatCountdown = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `00.${String(minutes).padStart(2, "0")}.${String(seconds).padStart(2, "0")}`;
  };

  useEffect(() => {
    let timerInterval;
  
    if (tender && tender.bidOpeningDate) {
      const openingDate = new Date(tender.bidOpeningDate);
  
      const updateTimer = () => {
        const now = new Date();
        const elapsed = now.getTime() - openingDate.getTime();
        const msPassedThisHour = elapsed % (60 * 60 * 1000);
        const msLeft = (60 * 60 * 1000) - msPassedThisHour;
        setTimeLeft(formatCountdown(msLeft));
      };
  
      updateTimer();
  
      timerInterval = setInterval(updateTimer, 1000);
    }
  
    return () => clearInterval(timerInterval);
  }, [tender]);
  
  return (
    <div style={{position:'relative'}}>
      {loading && <div className="loading-div"></div> }
      {tender && (
        <>
          <BasicTenderInfo tender={tender} />
          <Typography variant="h6">Bid Openers</Typography>
          <Box className="dashboard-container" textAlign={"center"}>
            <Typography variant="h5" fontWeight={500}>
              Total Bid Openers
            </Typography>
            <Typography variant="h2" sx={{ fontWeight: 700, color: "#00BE13" }}>
              0{tender?.openers[0]?.noOfOpeners}
            </Typography>
          </Box>
          <Box className="dashboard-container" mx={40} mt={10} sx={{position: 'relative'}}>
            <div className="tender-title" style={{width: "40%", background: "#00BE13", fontSize: "1.2rem", top: "-2%"}}>Bid Opener</div>
            <Box sx={{display: 'flex', justifyContent: 'end'}}>
                <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Typography>Timer <br /></Typography>
                    <Typography variant="h5" fontWeight={700}>{bidsOpened ? `00.00.00` : timeLeft}</Typography>
                </Box>
            </Box>
            <Box sx={{display: 'flex', justifyContent: 'center', my: 7}}>
                <img src={person} alt="" />
            </Box>
            <Box className="btn-container">
                {decrypted ?
                bidsOpened ? 
                <Button className="btn-contained" sx={{background: "#FFD900 !important"}} disabled>All Bids Opened</Button>
                 :
                <Button className="btn-contained" sx={{background: "#FFD900 !important"}} disabled>Waiting For Others</Button>
                :
                <Button className="btn-outlined btn-reject" onClick={handleDecrypt} disabled={loading}>Decrypt Bid</Button>
                }
            </Box>
          </Box>
        </>
      )}
    </div>
  );
};

export default DecryptBid;
